
import React from 'react';

const CompanyIntro: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
         <div>
  <h2 className="text-4xl font-bold text-gray-900 mb-6">
    关于<strong>北京生因科技</strong>
  </h2>

          <div className="space-y-6 text-gray-600 leading-relaxed text-lg">
            
            <p>
              北京生因科技有限公司（BioGene）是一家专注于<strong>科研创新与数据驱动研究</strong>的科技服务机构，为科研工作者提供从课题设计、实验执行到数据解析与论文发表的全流程支持。
            </p>

            <p>
              我们提供涵盖<strong>高通量测序</strong>、<strong>实验外包</strong>、<strong>生物信息学与多组学分析</strong>、<strong>AI/机器学习建模</strong>、<strong>科研思路咨询</strong>以及<strong>论文写作与润色</strong>等核心服务，帮助研究者高效推进课题、提升成果质量。
            </p>

            <p>
              团队成员来自清华大学、北京大学、Harvard、MIT 等国际顶尖科研机构，在肿瘤学、免疫学、衰老、发育、神经退行性疾病及心脑血管疾病领域拥有深厚积累，已协助多名客户发表多篇影响因子10分以上的SCI论文。
            </p>

          </div>
        </div>

          
          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20bioinformatics%20research%20team%20working%20with%20advanced%20genomic%20analysis%20equipment%2C%20scientists%20collaborating%20on%20multi-omics%20data%20integration%2C%20professional%20laboratory%20environment%20with%20DNA%20sequencing%20machines%20and%20computers%20displaying%20biological%20networks&width=600&height=500&seq=company-intro&orientation=portrait"
              alt="北京生因科技团队"
              className="w-full rounded-xl shadow-lg object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyIntro;